/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResolveIntegrationEventResponseData } from './ResolveIntegrationEventResponseData';
import {
    ResolveIntegrationEventResponseDataFromJSON,
    ResolveIntegrationEventResponseDataFromJSONTyped,
    ResolveIntegrationEventResponseDataToJSON,
} from './ResolveIntegrationEventResponseData';

/**
 *
 * @export
 * @interface ResolveIntegrationEventResponse
 */
export interface ResolveIntegrationEventResponse {
    /**
     * An outstanding bed conflict (an other-lead occupancy) that must be resolved before the Undo Move-Out can apply; null when the event was applied.
     * @type {ResolveIntegrationEventResponseData}
     * @memberof ResolveIntegrationEventResponse
     */
    data?: ResolveIntegrationEventResponseData | null;
}

/**
 * Check if a given object implements the ResolveIntegrationEventResponse interface.
 */
export function instanceOfResolveIntegrationEventResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResolveIntegrationEventResponseFromJSON(json: any): ResolveIntegrationEventResponse {
    return ResolveIntegrationEventResponseFromJSONTyped(json, false);
}

export function ResolveIntegrationEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveIntegrationEventResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : ResolveIntegrationEventResponseDataFromJSON(json['data']),
    };
}

export function ResolveIntegrationEventResponseToJSON(value?: ResolveIntegrationEventResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': ResolveIntegrationEventResponseDataToJSON(value.data),
    };
}
